import { ContractSettingsUnconditionalDisplayAs, ContractSettingsUnderOfferDisplayAs } from '@urbanx/agx.agencies.client'
import { ApiRequestBody } from 'interfaces/ApiRequestBody'
import AgencyService from 'services/agenciesService'

interface UpdateContractSettingsRequest extends ApiRequestBody {
  contractsEmail?: string
  settlementPlace?: string
  titleEncumbrances?: string
  underOfferDisplayAs?: ContractSettingsUnderOfferDisplayAs
  unconditionalDisplayAs?: ContractSettingsUnconditionalDisplayAs
  AgencyId?: string
}

const UpdateContractSettings = async (
  requestBody: UpdateContractSettingsRequest
): Promise<number | undefined> => {
  const { getAuthToken, AgencyId, ...requestProperties } = requestBody

  if (!AgencyId) return

  const token = await getAuthToken()
  const service = new AgencyService(token)

  const result = await service.agencyService.put(
    `UpdateContractSettings?AgencyId=${AgencyId}`,
    { ...requestProperties }
  )

  return result.status
}

export default UpdateContractSettings
